import React from 'react';
import SortableTH from './sortable-th';
import _ from 'lodash';

/* eslint-disable react/prop-types */
export default function SortableTableHeader({ headers }) {
  return (
    <thead>
      <tr>
        {_.map(headers, (header, index) =>
          <SortableTH key={index} {...header} />
        )}
      </tr>
    </thead>
  );
}



// WEBPACK FOOTER //
// ./app/components/content-containers/tables/sortable-table-header.js